import Temperature from './Temperature.svg'

export const TemperatureIcon = Temperature
